import React, { useState } from 'react';
import {
    Paper,
    Table,
    TableBody,
    TableRow,
    TableCell,
    Checkbox,
    DialogTitle,
    DialogContent,
    TableContainer,
    Button,
    Grid,
    DialogActions,
    Select,
    MenuItem,
    Chip
} from '@material-ui/core';
import { CheckCircleOutline, Close } from '@material-ui/icons';

export function AddDefect({ initialDefectIds, defectLevels, defects, onDone, onAbort }) {
    const [selectedLevel1Id, setSelectedLevel1Id] = useState(0);
    const [selectedLevel2Id, setSelectedLevel2Id] = useState(0);
    const [selectedDefectIds, setSelectedDefectIds] = useState([...initialDefectIds]);

    const handleAddDefect = defectId => {
        const hasDefect = selectedDefectIds.includes(defectId);
        const newSelectedDefectIds = hasDefect
            ? selectedDefectIds.filter(dId => dId !== defectId)
            : [...selectedDefectIds, defectId];
        setSelectedDefectIds(newSelectedDefectIds);
    };

    const handleDeleteDefect = defectId => {
        setSelectedDefectIds(selectedDefectIds.filter(dId => dId !== defectId));
    };

    const handleDone = () => {
        onDone(selectedDefectIds);
    };

    const currentLevel2Items = defectLevels.level2.filter(l => l.level1Id === selectedLevel1Id);
    const currentDefects = defects.filter(s => s.CategoryLevel2Id === selectedLevel2Id);

    return (
        <>
            <Grid container justifyContent="space-between">
                <Grid item>
                    <DialogTitle>Add Defects</DialogTitle>
                </Grid>
            </Grid>
            <DialogContent>
                <Grid container direction="column" spacing={1}>
                    <Grid item>
                        <Select
                            value={selectedLevel1Id}
                            onChange={e => {
                                setSelectedLevel1Id(Number(e.target.value));
                                setSelectedLevel2Id(0);
                            }}
                            fullWidth
                        >
                            <MenuItem value={0}>Category Hierarcy 1</MenuItem>
                            {defectLevels.level1.map(l => (
                                <MenuItem key={l.level1Id} value={l.level1Id}>
                                    {l.level1Desc}
                                </MenuItem>
                            ))}
                        </Select>
                    </Grid>
                    <Grid item>
                        <Select
                            value={selectedLevel2Id}
                            disabled={!selectedLevel1Id}
                            onChange={e => {
                                setSelectedLevel2Id(Number(e.target.value));
                            }}
                            fullWidth
                        >
                            <MenuItem value={0}>Category Hierarcy 2</MenuItem>
                            {currentLevel2Items.map(l => (
                                <MenuItem key={l.level2Id} value={l.level2Id}>
                                    {l.level2Desc}
                                </MenuItem>
                            ))}
                        </Select>
                    </Grid>
                    <Grid item>
                        <Grid container spacing={1} wrap="wrap" style={{ maxWidth: 440 }}>
                            {selectedDefectIds.length > 0 &&
                                selectedDefectIds.map(defectId => {
                                    const defect = defects.find(d => d.Code === defectId);
                                    return (
                                        <Grid item key={defect.Code}>
                                            <Chip
                                                size="small"
                                                label={defect.UserCode}
                                                onDelete={() => {
                                                    handleDeleteDefect(defectId);
                                                }}
                                                color="secondary"
                                                style={{ margin: 2 }}
                                            />
                                        </Grid>
                                    );
                                })}
                        </Grid>
                    </Grid>
                    <Grid item>
                        <TableContainer
                            component={Paper}
                            style={{ height: 400, width: 440, overflowY: 'auto', userSelect: 'none' }}
                        >
                            <Table size="small">
                                <TableBody>
                                    {currentDefects.map(defect => {
                                        const isItemSelected = selectedDefectIds.includes(defect.Code);
                                        return (
                                            <TableRow
                                                key={defect.Code}
                                                role="checkbox"
                                                onClick={() => {
                                                    // defect.Code as the defectId
                                                    handleAddDefect(defect.Code);
                                                }}
                                                selected={isItemSelected}
                                            >
                                                <TableCell component="th" scope="row">
                                                    {defect.UserCode} - {defect.DefectDesc}
                                                </TableCell>
                                                <TableCell padding="checkbox">
                                                    <Checkbox color="primary" checked={isItemSelected} />
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    size="small"
                    color="primary"
                    variant="contained"
                    onClick={handleDone}
                    endIcon={<CheckCircleOutline />}
                >
                    Done
                </Button>
                <Button size="small" color="secondary" variant="outlined" onClick={onAbort} endIcon={<Close />}>
                    Abort
                </Button>
            </DialogActions>
        </>
    );
}
